import React from 'react';
import { NavLink } from 'react-router-dom';
import { toastr } from 'react-redux-toastr';
import NavigationComponent from '../commonComponents/util/NavigationComponent';

export default class Header extends NavigationComponent {
  constructor(props) {
    super(props);

    this.state = {
      showMobileMenu: false,
      showAccountDropdown: false,
      savingAiSummaryPreference: false
    };

    this.accountDropdownRef = React.createRef();
    this.handleDocumentClick = this.handleDocumentClick.bind(this);
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleDocumentClick, true);
    document.addEventListener('touchstart', this.handleDocumentClick, true);
    document.addEventListener('click', this.handleDocumentClick, true);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleDocumentClick, true);
    document.removeEventListener('touchstart', this.handleDocumentClick, true);
    document.removeEventListener('click', this.handleDocumentClick, true);
  }

  handleDocumentClick(event) {
    if (
      this.state.showAccountDropdown &&
      this.accountDropdownRef.current &&
      !this.accountDropdownRef.current.contains(event.target)
    ) {
      this.setState({ showAccountDropdown: false });
    }
  }

  updateAiSummaryPreference = async event => {
    const showAiSummaries = event.target.checked;
    this.setState({ savingAiSummaryPreference: true });

    const response = await this.props.updateAiSummaryPreference(showAiSummaries);
    if (!response.success) {
      toastr.error('Something went wrong', 'We were unable to save your AI summary preference.');
    }

    this.setState({ savingAiSummaryPreference: false });
  };

  render() {
    const firstName = this.props.userProfile && this.props.userProfile.firstName
      ? this.props.userProfile.firstName
      : '';
    const lastName = this.props.userProfile && this.props.userProfile.lastName
      ? this.props.userProfile.lastName
      : '';
    const fullName = `${firstName} ${lastName}`.trim() || 'User';
    const email = this.props.userProfile && (
      this.props.userProfile.email ||
      this.props.userProfile.userName ||
      this.props.userProfile.username
    )
      ? (this.props.userProfile.email || this.props.userProfile.userName || this.props.userProfile.username)
      : '';
    const firstInitial = firstName ? firstName.charAt(0).toUpperCase() : 'U';
    const lastInitial = lastName ? lastName.charAt(0).toUpperCase() : '';
    const userInitials = `${firstInitial}${lastInitial}`;
    const showAiSummaries = !this.props.userProfile || this.props.userProfile.showAiSummaries !== false;

    return (
      <div>
        <header>
          <div className="header-left">
            <img src="/images/logo-white.png" alt="logo" />
          </div>
          <div className="header-center">
            <ul className="nav">
              {this.props.userPermissions.viewApplications && <li>
                <NavLink to="/applications" activeClassName="active">
                  <i className="icon-layers" />
                  Applications
               </NavLink>
              </li>}
              {this.props.userPermissions.viewRecipients && <li>
                <NavLink to="/recipient-accounts" activeClassName="active">
                  <i className="icon-people" />
                  Recipients
               </NavLink>
              </li>}
              {this.props.userPermissions.viewCampaigns && <li>
                <NavLink to="/campaigns" activeClassName="active">
                  <i className="icon-volume-2" />
                  Campaigns
               </NavLink>
              </li>}
              {this.props.userPermissions.viewAccounting && <li>
                <NavLink to="/accounting" activeClassName="active">
                  <i className="icon-calculator" />
                  Accounting
               </NavLink>
              </li>}
              {this.props.userPermissions.admin && <li>
                <NavLink to="/settings" activeClassName="active">
                  <i className="icon-settings" />
                  Admin
               </NavLink>
              </li>}
            </ul>
          </div>
          <div className="header-right">
            <div className="account-dropdown-container" ref={this.accountDropdownRef}>
              <button
                type="button"
                className="account-avatar-trigger"
                onClick={() => this.setState({ showAccountDropdown: !this.state.showAccountDropdown })}
              >
                <span className="account-avatar-initial">{userInitials}</span>
              </button>
              <div className={`dropdown-box ${this.state.showAccountDropdown ? 'active' : ''}`}>
                <div className="dropdown-user-info">
                  <span className="dropdown-user-icon">{userInitials}</span>
                  <div className="dropdown-user-text">
                    <p className="dropdown-user-name">{fullName}</p>
                    <p className="dropdown-user-email">{email}</p>
                  </div>
                </div>
                <div className="dropdown-ai-summary-setting">
                  <label htmlFor="toggle-ai-summaries" className="dropdown-ai-summary-label">AI summaries</label>
                  <div className="dropdown-ai-summary-control">
                    <span className="dropdown-ai-summary-state">{showAiSummaries ? 'On' : 'Off'}</span>
                    <input
                      type="checkbox"
                      id="toggle-ai-summaries"
                      className="cbx account-ai-summary-checkbox input"
                      checked={showAiSummaries}
                      disabled={this.state.savingAiSummaryPreference}
                      onChange={this.updateAiSummaryPreference}
                    />
                    <label
                      htmlFor="toggle-ai-summaries"
                      className={`toggle input ${this.state.savingAiSummaryPreference ? 'disabled' : ''}`}
                    />
                  </div>
                </div>
                <ul>
                  <li>
                    <button
                      onClick={() => { this.setState({ showAccountDropdown: false }); this.props.logout(); }}
                      disabled={this.props.loggingOut}
                    >
                      <i className="material-icons">exit_to_app</i>
                      Sign out
                    </button>
                  </li>
                </ul>
              </div>
            </div>
            <div className="mobile-menu-icon" onClick={() => this.setState({ showMobileMenu: true })}>
              <i className="material-icons open-menu">menu</i>
            </div>
          </div>
        </header>
        {this.state.showAccountDropdown && (
          <div
            className="account-dropdown-backdrop"
            onClick={() => this.setState({ showAccountDropdown: false })}
          />
        )}
        <div className={`mobile-menu ${!this.state.showMobileMenu ? 'closed-menu' : ''}`}>
          <div className="mobile-menu-header">
            <p className="mobile-menu-header-text" onClick={() => this.setState({ showMobileMenu: false })}><i className="material-icons close-menu" onClick={() => this.setState({ showMobileMenu: false })}>close</i>Close</p>
          </div>
          <ul>
            {this.props.userPermissions.viewApplications && <li>
              <NavLink to="/applications" activeClassName="active">
                <i className="icon-layers" />
                Applications
               </NavLink>
            </li>}
            {this.props.userPermissions.viewRecipients && <li>
              <NavLink to="/recipient-accounts" activeClassName="active">
                <i className="icon-people" />
                Recipients
               </NavLink>
            </li>}
            {this.props.userPermissions.viewCampaigns && <li>
              <NavLink to="/campaigns" activeClassName="active">
                <i className="icon-volume-2" />
                Campaigns
               </NavLink>
            </li>}
            {this.props.userPermissions.viewAccounting && <li>
              <NavLink to="/accounting" activeClassName="active">
                <i className="icon-calculator" />
                Accounting
               </NavLink>
            </li>}
            {this.props.userPermissions.admin && <li>
              <NavLink to="/settings" activeClassName="active">
                <i className="icon-settings" />
                Admin Settings
               </NavLink>
            </li>}
          </ul>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/layoutComponents/Header.jsx